import { CSVLink } from "react-csv";
import styled from "styled-components";


export default function StammdatenExport({ csvedData, csvHeader, csvFilename }) {
    const tinkerName = csvFilename => {
        let date = new Date().toJSON().slice(0, 10);
        // "2022-06-17"
        return csvFilename + "_" + date + ".csv";
    }
    return (
        <MyLink>
            <CSVLink className="link" data={csvedData} headers={csvHeader} separator={";"} target="_blank" filename={tinkerName(csvFilename)}>
                Daten exportieren
            </CSVLink>
        </MyLink >

    )
}

const MyLink = styled.div`
    width: fit-content;
    padding: 0.2em;
    margin-left: 7em;
    .link {
        color: rgb(0,139,139);
        font-size: 1.2em;
        font-weight: bold;
    }
`

//switch to csv format
//   const csvIt = loadedData => {
//     return loadedData.map(it =>
//     ({
//       ...it,
//       fahrtage: it.fahrtage.toLocaleString(),
//       fahrtenpaare: it.fahrtenpaare ? it.fahrtenpaare.toLocaleString() : "",
//       besetzung: it.besetzung ? it.besetzung.toLocaleString() : "",
//       code: btoa(JSON.stringify({
//         id: it.absDatId,
//         jahr: it.jahr
//       }))
//     }))
//   }